export interface IDOOP {
    DoopUser: DoopUser[],
    CurrentLog: "",
    Meta: ProjectMeta,
    AllAreas: Area[],
    Error: string,
}

export interface Contractor {
    kind: "contractor",
    Name: string,
}

export interface Area {
    name: string,
    id: number,
    identifier: string,
}

export interface DoopUser {
    canAcceptOrders: boolean,
    canInitiateProcess: boolean,
    email: string,
    isContractor: boolean,
    isOrderInformed: boolean,
    name: string,
    areas: string[],
}


export interface IDoopOrder {
    area?: string,
    name?: string,
    id?: string,
    estimatedHours?: number,
    priceModel?: string,
    orderNumber?: string,
    journeyState?: string,
    dateDone?: string,
    dateModified?: string,
    dateCreated?: string,
    isActive?: string,
    isDone?: string,
    isOrdered?: string,
    logs?: string,
    projectName?: string,
    rawProjectName?: string,
    uri?: string,
    rowKew?: string,
    partitionKey?: string,
}

export enum SearchBy {
    LastModified = "lastModified",
    AcceptanceDate = "acceptanceDate",
}



export interface ProjectMeta {
    debugMode: boolean,
    name: string,
    nameRaw: string,
    defaultOrderNumber: string,
    defaultPriceModel: string,
    doopAreas: string[],
    contractors: Contractor[],

    [key: string]: string | string[] | boolean | Contractor[]
}
